module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-195.af35f94.woff2";